import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "[wall-type-7]",
  templateUrl: "./wall-type-7.component.html",
  styleUrls: ["./wall-type-7.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WallType7Component {
  height = input<number>();

  leftWallPoints = computed(() => this.getWallPoints(this.height(), "left"));
  rightWallPoints = computed(() => this.getWallPoints(this.height(), "right"));

  // catalog
  private getWallPoints(baseHeight: number, wallSide: "left" | "right"): string {
    const wallData = {
        left: `M0 101 L187 211 L187 ${baseHeight + 80} L0 ${baseHeight - 30} Z`,
        right: `M187 211 L375 101 L375 ${baseHeight - 30} L187 ${baseHeight + 80} Z`
    };

    return wallData[wallSide];
  }
}
